/**
 * Chat Index - Redirect to Chat Properties
 * 
 * This component redirects users to the Chat Properties page where they can:
 * - Select a teacher
 * - View and continue previous sessions
 * - Start new learning sessions
 */

import React, { useEffect } from 'react';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import Header from '../../components/layout/Header';
import Footer from '../../components/layout/Footer';

const Chat = () => {
  const { profileId } = useParams();
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session');

  useEffect(() => {
    // Redirect to appropriate page based on session parameter
    const userId = profileId || currentUser?.uid;
    
    if (!userId) {
      console.error('No valid user ID available');
      return;
    }
    
    if (sessionId) {
      // If session ID provided, go directly to realtime session
      navigate(`/chat/${userId}/realtime?session=${sessionId}`);
    } else {
      // Otherwise, go to chat properties for teacher selection
      navigate(`/chat/${userId}/properties`);
    }
  }, [profileId, currentUser, navigate, sessionId]);

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <div className="flex items-center justify-center h-screen">
        <div className="text-center">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-gradient-to-r from-blue-500 to-purple-600 mb-4 animate-pulse">
            <svg className="animate-spin h-10 w-10 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
          </div>
          <h3 className="text-xl font-semibold text-gray-800 mb-2">Redirecting to Learning Session</h3>
          <p className="text-gray-600">Setting up your personalized learning environment...</p>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Chat;

